import { createFileRoute } from "@tanstack/react-router";
import { EmployerSaintLanding } from "@/pages/employer-saint/EmployerSaintLanding";
import { americanAirlines } from "@/pages/employer-saint/employers";
export const Route = createFileRoute("/american-airlines-saint")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "American Airlines SAINT® | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Airline employees with depression: SAINT TMS is a 5-day, fMRI-guided treatment option. Learn about coverage and travel support from Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "American Airlines SAINT® | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Airline employees with depression: SAINT TMS is a 5-day, fMRI-guided treatment option. Learn about coverage and travel support from Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/american-airlines-saint",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/american-airlines-saint",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <EmployerSaintLanding employer={americanAirlines} />;
}
